import React, { useState, useEffect } from "react";
import { Filter, ShoppingCart } from "react-feather";
import VisitorNavbar from "../component/VisitorNavbar";
import Footer from "../component/Footer";
import { Link } from "react-router-dom";
import { baseurl, imageUrl } from "../Baseurl";
import axios from "axios";
import noproduct from "../component/img/product_not_found.jpeg";

const NewProduct = () => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [selectedConditions, setSelectedConditions] = useState([]);
  const [maxPrice, setMaxPrice] = useState(Infinity);

  const fetchProducts = async () => {
    try {
      const response = await axios.get(`${baseurl}getNewProducts`);
      const productList = response.data?.data || [];
      setProducts(productList);
      setFilteredProducts(productList);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching products:", err);
      setError("Failed to load products.");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const uniqueConditions = [...new Set(products.map((p) => p.condition || "N/A"))];

  const handleConditionChange = (condition) => {
    setSelectedConditions((prev) =>
      prev.includes(condition) ? prev.filter((c) => c !== condition) : [...prev, condition]
    );
  };

  const handlePriceChange = (event) => {
    const price = event.target.value ? parseFloat(event.target.value) : Infinity;
    setMaxPrice(price);
  };

  useEffect(() => {
    const filtered = products.filter(
      (product) =>
        (selectedConditions.length === 0 || selectedConditions.includes(product.condition || "N/A")) &&
        parseFloat(product.price) <= maxPrice
    );

    setFilteredProducts(filtered);
  }, [products, selectedConditions, maxPrice]);

  const selectedCurrency = sessionStorage.getItem("selectedCurrency") || "INR";
  const dollarRate = parseFloat(localStorage.getItem("dollarRate")) || 1;

  const convertPrice = (inrPrice) => {
    return selectedCurrency === "USD"
      ? `$${(inrPrice / dollarRate).toFixed(2)}`
      : `₹${inrPrice}`;
  };

  // Function to adjust max price based on currency
  const getMaxPriceInSelectedCurrency = (price) => {
    if (selectedCurrency === "USD") {
      return price; // No conversion needed, as the price is already in USD
    } else {
      return price * dollarRate; // Convert INR to USD for filtering
    }
  };

  return (
    <>
      <VisitorNavbar />
      <div className="container-fluid py-3">
        <div className="row g-4">
          {/* Filters */}
          <div className="col-md-2 hide-on-mobile">
            <h4 className="product-desc-title">Filters <Filter size={20} /></h4>
            <div className="filter-section p-2 border">
              {/* Condition Filter */}
              <div className="mb-3 text-start">
                <label className="form-label lab1">Condition</label>
                <div>
                  {uniqueConditions.map((condition) => (
                    <div key={condition} className="form-check">
                      <input
                        type="checkbox"
                        id={`condition-${condition}`}
                        className="form-check-input"
                        checked={selectedConditions.includes(condition)}
                        onChange={() => handleConditionChange(condition)}
                      />
                      <label htmlFor={`condition-${condition}`} className="form-check-label">
                        {condition}
                      </label>
                    </div>
                  ))}
                </div>
              </div>

              {/* Price Filter */}
              <div className="mb-3 text-start">
                <label className="form-label lab1">Max Price ({selectedCurrency === "USD" ? "$" : "₹"})</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder={`Enter max price in ${selectedCurrency === "USD" ? "$" : "₹"}`}
                  onChange={handlePriceChange}
                />
              </div>
            </div>
          </div>

          {/* Products */}
          <div className="col-md-10">
            <h4 className="product-desc-title">Shop Products</h4>
            {loading ? (
              <div className="d-flex justify-content-center align-items-center vh-50">
                <div className="spinner-border text-danger" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : error ? (
              <p className="text-danger">{error}</p>
            ) : (
              <div className="row g-2">
                {filteredProducts.length > 0 ? (
                  filteredProducts.map((product) => (
                    <div className="col-md-3 col-6 " key={product.id}>
                      <div className="product-card">
                        <img
                          src={
                            product.listing_image
                              ? `${imageUrl}listing/${product.listing_image}`
                              : noproduct
                          }
                          alt={product.title}
                        />
                        <div className="text-start">
                          <span className="cntn">{product.condition}</span>
                        </div>
                        <h3>{product.title}</h3>
                        <div className="price">
                          <span className="current-price">
                            {convertPrice(product.price)}
                          </span>
                        </div>
                        <Link to={`/product/${product.slug}`} className="btn add-to-cart">
                          <ShoppingCart size={16} />&nbsp;
                          {product.type === "quoteRequest" ? "View Details" : "View Details"}
                        </Link>
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="text-center">
                    <img src={noproduct} className="img-fluid noproductimg" alt="No Product Found" />
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NewProduct;
